import React from 'react';
import { motion } from 'framer-motion';
import { Target, Zap } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const baseFeatures = ['✅ TOMO 1: Fundamentos de la Gestión Ambiental', '✅ TOMO 2: Recursos Naturales y Conservación', '✅ TOMO 3: Gestión de Residuos y Economía Circular', '✅ TOMO 4: Contaminación y Control Ambiental', '✅ TOMO 5: Cambio Climático y Sostenibilidad', '✅ TOMO 6: Proyectos Ambientales Escolares', '🎁 BONUS 1: 100 Actividades Ambientales para el Aula', '🎁 BONUS 2: 100 Evaluaciones Listas para Imprimir', '🎁 BONUS 3: 6 Proyectos Ambientales Escolares Listos', '🎁 BONUS 4: Efemérides Ambientales 2026', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const expertoFeatures = ['✅ TOMO 1: Fundamentos de la Gestión Ambiental', '✅ TOMO 2: Recursos Naturales y Conservación', '✅ TOMO 3: Gestión de Residuos y Economía Circular', '✅ TOMO 4: Contaminación y Control Ambiental', '✅ TOMO 5: Cambio Climático y Sostenibilidad', '✅ TOMO 6: Proyectos Ambientales Escolares', '🎁 BONUS 1: 100 Actividades Ambientales para el Aula', '🎁 BONUS 2: 100 Evaluaciones Listas para Imprimir', '🎁 BONUS 3: 6 Proyectos Ambientales Escolares Listos', '🎁 BONUS 4: Efemérides Ambientales 2026', '🚀 NIVEL EXPERTO: Kit de Implementación Docente', '🏆 NIVEL EXPERTO: Kit de Certificación y Autoridad Docente', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const comparisonRows = [{
    sit: 'Implementar el proyecto ambiental',
    sin: 'Sabés qué hacer pero no cómo organizarte',
    con: 'Planificador anual completo mes a mes + sistema de alertas'
  }, {
    sit: 'Medir el impacto de tus acciones',
    sin: 'No tenés indicadores ni forma de mostrar resultados',
    con: 'Tablero diario, semanal, mensual y anual'
  }, {
    sit: 'Comunicar el proyecto a directivos',
    sin: 'Explicás de palabra sin documentación',
    con: 'Nota formal + presentación lista'
  }, {
    sit: 'Involucrar a las familias',
    sin: 'Enviás alguna nota suelta',
    con: 'Kit completo: carta, boletín, 20 posts para redes listos'
  }, {
    sit: 'Certificar los aprendizajes de alumnos',
    sin: 'No hay reconocimiento formal',
    con: '4 tipos de certificados + insignias + rúbrica oficial'
  }, {
    sit: 'Capacitar a otros docentes',
    sin: 'No sabés por dónde empezar',
    con: '3 talleres completos con guión actividad por actividad'
  }, {
    sit: 'Posicionarte como referente ambiental',
    sin: 'Tu trabajo es invisible',
    con: 'Portfolio profesional de 7 secciones físico y digital'
  }, {
    sit: 'Gestionar alianzas con el municipio',
    sin: 'No tenés el documento formal',
    con: 'Carta de alianza lista para firmar'
  }];
  const expertoKit = [{
    icon: '📋',
    title: 'PLANIFICADOR ANUAL DOCENTE',
    desc: 'Sistema completo de planificación del ciclo lectivo ambiental: diagnóstico inicial, mapa de tiempo curricular, matriz de articulación con todas las asignaturas, planificadores mensuales detallados de marzo a diciembre y evaluación docente anual.'
  }, {
    icon: '📊',
    title: 'TABLERO DE SEGUIMIENTO INSTITUCIONAL',
    desc: '4 niveles de monitoreo: tablero diario para alumnos, semanal para el docente, mensual para directivos y anual de impacto. Tableros específicos para cada uno de los 6 proyectos del Bonus 3. Sistema de alertas tempranas para detectar problemas antes de que sea tarde.'
  }, {
    icon: '👨‍👩‍👧',
    title: 'KIT DE COMUNICACIÓN CON FAMILIAS Y COMUNIDAD',
    desc: '10 documentos listos para usar: nota a directivos, carta a familias, boletín ambiental mensual, informe trimestral, protocolo de WhatsApp con 20 mensajes tipo, convocatoria a jornada familiar, propuesta de alianza al municipio, 20 publicaciones para redes sociales listas para publicar todo el año, protocolo de crisis y encuesta de satisfacción.'
  }, {
    icon: '📁',
    title: 'PORTFOLIO PROFESIONAL AMBIENTAL',
    desc: 'Sistema completo de 7 secciones para documentar y presentar tu trayectoria: perfil profesional, formación, proyectos implementados, materiales producidos, evidencias de impacto, testimonios y objetivos futuros. Guía para crear tu portfolio digital. Formatos para inspección, concurso docente, congreso o beca.'
  }, {
    icon: '🎓',
    title: 'SISTEMA DE CERTIFICACIÓN DE ALUMNOS',
    desc: '4 tipos de certificados listos para imprimir, sistema gamificado de 12 insignias ambientales, rúbrica oficial de competencias ambientales con 12 criterios en 3 dimensiones, protocolo de certificación para ferias de ciencias y pasaporte ambiental del alumno.'
  }, {
    icon: '👨‍🏫',
    title: 'KIT DEL DOCENTE CAPACITADOR',
    desc: '3 talleres completos con guión detallado: Taller 1 (Introducción a la GA, 3 horas), Taller 2 (Diseño de proyectos, 4 horas), Taller 3 (Evaluación ambiental, 2 horas). Programa anual de capacitación. Certificado para docentes. Guía para gestionar el reconocimiento oficial en el legajo docente.'
  }];
  return <section id="pricing" className="py-24 bg-[#ece2cd]" data-id="element-204">
      <div className="container mx-auto px-4" data-id="element-205">
        <div className="text-center mb-16" data-id="element-206">
          <h2 className="text-[28px] md:text-5xl font-black text-[#1e4230] mb-4 font-[Merriweather,_serif]" data-id="element-207">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-[#6f4e2e] text-[16px]" data-id="element-208">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-209">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-[0_16px_40px_-20px_rgba(31,50,39,0.4)] border border-[#e0d6bf] flex flex-col h-full relative z-10" data-id="element-210">
            <div className="mb-6" data-id="element-211">
              <p className="text-[#a97e12] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-212">
                OPCIÓN 1 — Oferta principal
              </p>
              <h3 className="font-black text-[#1e4230] mb-2 flex items-center gap-2 text-[20px] font-[Merriweather,_serif]" data-id="element-213">
                🌿 MEGAPACK GESTIÓN AMBIENTAL LISTO™
              </h3>
              <p className="text-[#6f4e2e] font-medium" data-id="element-214">6 Tomos + 4 Bonos</p>
            </div>

            <div className="mb-6 pb-6 border-b border-[#e0d6bf]" data-id="element-215"></div>

            <div className="mb-8" data-id="element-216">
              <div className="flex items-end gap-2" data-id="element-217">
                <span className="text-5xl font-black text-[#1e4230]" data-id="element-218">
                  $19.990
                </span>
                <span className="text-xl font-bold text-[#6f4e2e] mb-1" data-id="element-219">
                  ARS
                </span>
              </div>
              <p className="text-[#a08a6a] line-through mt-1" data-id="element-220">$55.000 ARS</p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-221">
              {baseFeatures.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-222">
                  <span className="text-[#4a4133] text-[15px]" data-id="element-223">{feature}</span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/48009126445250:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-224">
              <Button variant="outline" size="lg" fullWidth data-id="element-225">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-3xl p-8 shadow-[0_16px_40px_-20px_rgba(31,50,39,0.5)] border-2 border-[#c8971b] flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-226">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#c8971b] text-[#14301f] font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-227">
              <Zap className="w-4 h-4 fill-[#14301f]" data-id="element-228" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-229">
              <h3 className="font-black text-[#1e4230] mb-2 flex items-center gap-2 text-[19px] font-[Merriweather,_serif]" data-id="element-230">
                🌿 MEGAPACK GESTIÓN AMBIENTAL LISTO™ + NIVEL EXPERTO
              </h3>
              <p className="text-[#a97e12] font-bold" data-id="element-231">
                Todo lo anterior + Kit de Implementación y Certificación
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-[#e0d6bf]" data-id="element-232"></div>

            <div className="mb-8" data-id="element-233">
              <div className="flex items-end gap-2" data-id="element-234">
                <span className="text-5xl font-black text-[#1e4230]" data-id="element-235">
                  $27.990
                </span>
                <span className="text-xl font-bold text-[#6f4e2e] mb-1" data-id="element-236">
                  ARS
                </span>
              </div>
              <p className="text-[#a08a6a] line-through mt-1" data-id="element-237">$85.000 ARS</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-238">
              {expertoFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-239">
                  <Zap className="w-5 h-5 text-[#c8971b] shrink-0 mt-0.5" data-id="element-240" />
                  <span className={i >= 10 ? 'text-[#1e4230] font-bold' : 'text-[#4a4133]'} data-id="element-241">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/48009128116418:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-242">
              <Button variant="premium" size="lg" fullWidth data-id="element-243">
                ⚡ QUIERO EL MEGAPACK + NIVEL EXPERTO
              </Button>
            </a>
          </motion.div>
        </div>

        <p className="text-center text-[#6f4e2e] text-sm mb-20" data-id="element-244">
          Podés pagar con tarjeta de crédito o débito, transferencia bancaria o
          Mercado Pago en pesos argentinos.
        </p>

        {/* Upsell Details */}
        <div className="max-w-4xl mx-auto" data-id="element-245">
          <div className="text-center mb-10" data-id="element-246">
            <h3 className="text-2xl md:text-3xl font-black text-[#1e4230] flex items-center justify-center gap-2 font-[Merriweather,_serif]" data-id="element-247">
              <Target className="w-8 h-8 text-[#c8971b]" data-id="element-248" />
              🎯 ¿QUÉ AGREGA EL NIVEL EXPERTO?
            </h3>
          </div>

          <div className="overflow-x-auto pb-4 mb-12" data-id="element-249">
            <div className="min-w-[700px]" data-id="element-250">
              <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-251">
                <div className="font-bold text-[#6f4e2e] uppercase text-sm tracking-wider" data-id="element-252">
                  Situación
                </div>
                <div className="font-bold text-[#9c3f22] uppercase text-sm tracking-wider" data-id="element-253">
                  ❌ Sin Nivel Experto
                </div>
                <div className="font-bold text-[#2f6b47] uppercase text-sm tracking-wider" data-id="element-254">
                  ✅ Con Nivel Experto
                </div>
              </div>

              <div className="space-y-2" data-id="element-255">
                {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-white rounded-xl p-4 items-center border border-[#e0d6bf]" data-id="element-256">
                    <div className="text-[#1e4230] font-medium text-sm" data-id="element-257">
                      {row.sit}
                    </div>
                    <div className="text-[#9c3f22]/90 text-sm" data-id="element-258">{row.sin}</div>
                    <div className="text-[#1e4230] font-medium text-sm" data-id="element-259">
                      {row.con}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="bg-[#1e4230] rounded-2xl p-6 md:p-8 border-2 border-[#c8971b]/50 shadow-xl" data-id="element-260">
            <h4 className="font-black text-[#e7c766] mb-6 uppercase tracking-wider font-[Merriweather,_serif]" data-id="element-261">
              🚀 NIVEL EXPERTO — ¿QUÉ INCLUYE?
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-262">
              {expertoKit.map((item, i) => <div key={i} className="bg-[#14301f]/60 rounded-xl p-4 border border-[#2f6b47]/50" data-id="element-263">
                  <p className="font-bold text-[#f5efe1] flex items-center gap-2 mb-1" data-id="element-264">
                    <span className="text-[#e7c766] text-lg" data-id="element-265">{item.icon}</span>{' '}
                    {item.title}
                  </p>
                  <p className="text-[#c9d4c9] text-sm" data-id="element-266">{item.desc}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}